module.exports = __webpack_public_path__ + "img/56.a4aac19d.jpg";